import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © 2025 ליהי שירזי - יוצרת תוכן מקורי, מלווה עסקים, בונה להם אסטרטגיות שיווק דיגיטלי שמביאות תוצאות אמיתיות ומעלות את המותג שלך לרמה הבאה!
            </p>
            <div className="footer-bottom-links">
              <span className="footer-link">תנאי שימוש</span>
              <span className="footer-link">מדיניות פרטיות</span>
            </div>
          </div>
        </div>
      </div>

      {isVisible && (
        <button className="scroll-to-top" onClick={scrollToTop} aria-label="חזור למעלה">
          <FaArrowUp />
        </button>
      )}
    </footer>
  );
};

export default Footer;
